import { render, staticRenderFns } from "./DedicatePage2.vue?vue&type=template&id=7cf7a9ef&scoped=true&"
import script from "./DedicatePage2.vue?vue&type=script&lang=js&"
export * from "./DedicatePage2.vue?vue&type=script&lang=js&"
import style0 from "./DedicatePage2.vue?vue&type=style&index=0&id=7cf7a9ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf7a9ef",
  null
  
)

export default component.exports